/**
 * AAA IDP state of issue reducer
 * 
 */
import { DELETE, STATE_OF_ISSUE, VALIDATE } from '../../actions/types';
export const initialState = {
  error: false,
  required: true,
  valid: null,
  value: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case STATE_OF_ISSUE:
      {
        const {
          required
        } = state;
        const {
          value
        } = action;
        const valid = value === '' && required ? false : true;
        return {
          ...state,
          error: !valid,
          valid,
          value
        };
      }
    case VALIDATE:
      {
        const {
          required,
          value
        } = state;
        const valid = value === '' && required ? false : true;
        return {
          ...state,
          error: !valid,
          valid
        };
      }
    default:
      return state;
  }
}